import { render } from "./MfittBookingMailSentError.vue?vue&type=template&id=643dcf82"
import script from "./MfittBookingMailSentError.vue?vue&type=script&lang=js"
export * from "./MfittBookingMailSentError.vue?vue&type=script&lang=js"
script.render = render

export default script